import {
  lowerCaseUtf8ToAh033TransliterationRules,
  upperCaseUtf8ToAh033TransliterationRules,
} from 'common/src/vtj/utf8-to-ah033-transliteration-rules'

export const allowedAH033LowercaseChars =
  'abcdefghijklmnopqrstuvwxyzåäöáàâãçðéèêëìíîïñóòôõßúùüûýþæø'
export const allowedAH033UppercaseChars =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZÅÄÖÁÀÂÃÇÐÉÈÊËÌÍÎÏÑÓÒÔÕẞÚÙÛÝÜÞÆØ'
export const allowedAH033AlphabeticChars =
  allowedAH033LowercaseChars + allowedAH033UppercaseChars

export const allowedAH033SeparatorChars = "-' "
export const allowedAH033SpecialChars = './'

export const allowedAH033Chars =
  allowedAH033AlphabeticChars +
  allowedAH033SeparatorChars +
  allowedAH033SpecialChars

export const allowedAT033SpecialChars = '0123456789 (),/.-:'

export const allowedAT033Chars =
  allowedAH033AlphabeticChars + allowedAT033SpecialChars

export const allowedUtf8LowercaseChars = Object.keys(
  lowerCaseUtf8ToAh033TransliterationRules
).join('')
export const allowedUtf8UppercaseChars = Object.keys(
  upperCaseUtf8ToAh033TransliterationRules
).join('')
export const allowedUtf8Chars =
  allowedUtf8LowercaseChars + allowedUtf8UppercaseChars

export const allowedUppercaseChars =
  allowedAH033UppercaseChars + allowedUtf8UppercaseChars
export const allowedLowercaseChars =
  allowedAH033LowercaseChars + allowedUtf8LowercaseChars

export const allowedCharsWithSpace = allowedAH033Chars + allowedUtf8Chars + ' '

export const escapeSpecialChars = (chars) =>
  chars.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
